import Vue from 'vue'
import Router from 'vue-router'

//中文页面路由
const index = ()=> import('@/pages/index');
const home = ()=> import('@/pages/home');
const product = ()=> import('@/pages/product');
const productDetail = ()=>import('@/pages/product-detail')
const about = ()=> import('@/pages/about');
const resource = ()=> import('@/pages/resource');
const resourceDetail = ()=>import('@/pages/resource-detail')
const news = ()=> import('@/pages/news');
const newsDetail = ()=>import('@/pages/news-detail')
const contact = ()=>import('@/pages/contact')
//通用
const notFound = ()=> import('@/pages/not-found');
Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'index',
            component: index,
            redirect: '/home',
            children:[
                {
                    path: '/home',
                    name: 'home',
                    component: home,
                },
                {
                    path: '/product',
                    name: 'product',
                    component: product,
                },
                {
                    path: '/product-detail',
                    name: 'product-detail',
                    component: productDetail,
                },
                {
                    path: '/about',
                    name: 'about',
                    component: about
                },
                {
                    path: '/contact',
                    name: 'contact',
                    component: contact
                },
                {
                    path: '/resource',
                    name: 'resource',
                    component: resource
                },
                {
                    path: '/resource-detail',
                    name: 'resource-detail',
                    component: resourceDetail,
                },
                {
                    path: '/news',
                    name: 'news',
                    component: news
                },
                {
                    path: '/news-detail',
                    name: 'news-detail',
                    component: newsDetail,
                }
            ]
        },
        
        {
            path: '*',
            name: 'notFound',
            component: notFound
        }
    ]
})



// WEBPACK FOOTER //
// ./router/index.js